import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.css']
})
export class CancellationPolicyComponent implements OnInit {
  packageId: any;
  cancellationPolicy: any = [];
  overviewDataList: any = [];

  constructor(
    private route: ActivatedRoute,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.packageId = params.get('packageId');
      if (this.packageId) {
        this.getPolicyDataPlaceId();
        this.getOverviewDataPlaceData();
      }
    });
  }

  getPolicyDataPlaceId() {
    this.userLayoutService.getPolicyDataByPlaceId(this.packageId).subscribe(
      (response: any) => {
        if (response.code === 1) {
          let policyDataList = response.data;
          this.cancellationPolicy = policyDataList.find(
            (policy: any) => policy.policyName === "Cancellation Policy"
          );
        } else {
          console.error('Failed to fetch policy data');
        }
      },
      (error) => {
        console.error('Error fetching policy data:', error);
      }
    );
  }

  getOverviewDataPlaceData() {
    let dataObj = {
        packageId: this.packageId
    }
    this.userLayoutService.getOverviewDataByPlaceId(dataObj).subscribe((Response: any) => {

        if (Response.code == 1) {

            // setTimeout(() => {
            this.overviewDataList = Response.data;
            // }, 1000);
        }
        else {
        }
    }, (error) => {
    });
}
}
